<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useConfigStore } from '@/stores/config'

const configStore = useConfigStore()
</script>

<template>
  <div class="flex min-h-screen flex-col items-center justify-center bg-background">
    <div class="mb-8 flex flex-col items-center gap-2">
      <img
        v-if="configStore.branding.logoPath"
        :src="configStore.branding.logoPath"
        :alt="configStore.branding.appName"
        class="h-12 w-auto"
      />
      <h1 class="text-2xl font-semibold tracking-tight">{{ configStore.branding.appName }}</h1>
    </div>
    <RouterView />
  </div>
</template>
